// extracted by mini-css-extract-plugin
export default {"important":"ImportantQuestionAction_important__zy5qi","label":"ImportantQuestionAction_label__+PJ7h"};